export const CAMPAIGNS_COLUMNS = {
  // Email Sequencing columns — first group, first in selector
  workflow_status: {
    header: 'Status',
    group: 'Email Sequencing',
  },
  owner: {
    header: 'Owner',
    group: 'Email Sequencing',
  },
  launch_date: {
    header: 'Launch Date',
    group: 'Email Sequencing',
  },
  on_off: {
    header: 'On/Off',
    group: 'Email Sequencing',
  },
  interested_rate: {
    header: 'Interested Rate',
    group: 'Email Sequencing',
  },
  reply_count: {
    header: 'Replies',
    group: 'Email Sequencing',
  },
  unread_reply_count: {
    header: 'Unread',
    group: 'Email Sequencing',
  },
  action_needed: {
    header: 'Action Needed',
    group: 'Email Sequencing',
  },

  // Campaign Attributes
  name: {
    header: 'Name',
    group: 'Campaign Attributes',
  },
  description: {
    header: 'Description',
    group: 'Campaign Attributes',
  },
  company_type: {
    header: 'Opportunity Type',
    group: 'Campaign Attributes',
  },
  product: {
    header: 'Product',
    group: 'Campaign Attributes',
  },
  created: {
    header: 'Created',
    group: 'Campaign Attributes',
  },
  modified: {
    header: 'Last Updated',
    group: 'Campaign Attributes',
  },
  days_since_last_update: {
    header: 'Days Since Last Update',
    group: 'Campaign Attributes',
  },
  contact_company_count: {
    header: 'Opps Assigned',
    group: 'Campaign Attributes',
  },
  door_count: {
    header: 'Door Count',
    group: 'Campaign Attributes',
  },

  // Deals
  deal_count: {
    header: 'Deals',
    group: 'Deals',
  },
  deal_count_won: {
    header: 'Deals Won',
    group: 'Deals',
  },
  deal_perc: {
    header: 'Deals (%)',
    group: 'Deals',
  },
  deal_perc_won: {
    header: 'Deals Won (%)',
    group: 'Deals',
  },

  // Contacts
  contact_count: {
    header: 'Contacts Count',
    group: 'Contacts',
  },
  companies_with_contacts: {
    header: 'Companies With Contacts',
    group: 'Contacts',
  },
  companies_with_contacts_perc: {
    header: 'Companies With Contacts (%)',
    group: 'Contacts',
  },

  // Forecasts
  taro: {
    header: 'Annual Rev Opp',
    group: 'Forecasts',
  },
  taro_closed: {
    header: 'Annual Rev Opp (closed)',
    group: 'Forecasts',
  },
  est_meals_day: {
    header: 'Est. Meals / Day',
    group: 'Forecasts',
  },
}
